import React from 'react'
// view components
import { Table } from 'components/UI'
// components
import Row from './components/Row'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { ObjectivesPageContext } from 'containers/Objectives/Register/layers/API'
// utils
import { getTableHeader } from 'utils/index'

const ObjectivesTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, fields, refetch, totalCount, isRefetching } = React.useContext(ObjectivesPageContext)

  const headers = [
    {
      id: 'entity.description',
      sortable: true,
      left: true,
      label: getTableHeader('description', fields, 'DESCRIPTION')
    },
    { id: 'status', sortable: false, left: true, label: getTableHeader('status', fields, 'STATUS') },
    { id: 'associatedWith', sortable: false, left: true, label: 'ASSOCIATED WITH' },
    { id: 'nextReview', sortable: false, left: true, label: 'NEXT REVIEW' },
    {
      id: 'ownedBy',
      sortable: false,
      left: true,
      label: getTableHeader('ownedByEmployeeOrPosition', fields, 'OWNED BY')
    }
  ]

  return (
    <Table
      data={data}
      page={page}
      title='Objectives'
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) => data.map((item) => <Row key={item.id} data={item} fields={fields} />)}
    </Table>
  )
}

export default ObjectivesTable
